define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/def/Rule",
	"csi/util"
], function(declare,domClass,Rule,util) {

	return declare(Rule, {
		// Boolean: indicates if the Id/Path is relative to the root node rather than the referenced node
		bFromRoot: false,

		// Boolean: indicates if print-only rule to be applied on print page
		bPrint: false,

		constructor: function(def) {
			this.bPrint = util.getBooleanProperty(def, "Print");
			this.bFromRoot = util.getBooleanProperty(def, 'FromRoot');
		},

		isRule: function() {
			return true;
		},

		keyToHtml: function(/*Context*/ctx, /*DOMNode*/refNode) {
			// summary: apply CSS from rule to html if it passes
			if (this.passes(ctx.getNode(), ctx.cache, ctx)) {
				domClass.add(refNode, this.m_class);
			}
		}
	});
});